class ConcreteButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', async (event) => this.onUpdate(event.detail.concrete), true)
    document.addEventListener('concrete-model-update', async (event) => this.onUpdate(event.detail.concrete), true)
  }

  onUpdate(concreteModel) {
    let str = '<strong>Concrete</strong>'
    str += `<div>${concreteModel.designType}</div>`
    str += `<div>f'c = ${concreteModel.concreteStrength} ksi</div>`
    str += `<div>Thickness = ${concreteModel.concreteThickness} in</div>`
    str += `<div>${concreteModel.highSeismicZone ? 'Seismic Provisions Apply' : 'No Seismic Provisions'}</div>`
    document.getElementById('concrete-button').innerHTML = str
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-concrete-dialog" style="text-decoration: none;">
          <div class="card panel-shadow text-center" style="padding:10px;" id="concrete-button">
            <strong>Concrete</strong>
            <div>ACI Chapter 9</div>
            <div>f'c = 4.00 ksi</div>
            <div>thickeness = 15.00 in</div>
            <div>No Seismic Provisions</div>
          </div>
        </a>
      </div>
    `
  }
}

customElements.define('concrete-button-component', ConcreteButtonComponent);